import { render } from "./edit-social-post.vue?vue&type=template&id=1ef692d0&ts=true"
import script from "./edit-social-post.vue?vue&type=script&lang=ts"
export * from "./edit-social-post.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__